import { wrapper, createApiClient, Result, ApiError } from "../base";
import IntegrationDO = App.Data.Integrations.IntegrationDO;
import IntegrationExecutionDO = App.Data.Integrations.IntegrationExecutionDO;
import { LaravelPaginatedCollection } from "@/types/collections";

const baseClient = createApiClient();

export default class {
	get(params: {
		page: number;
		itemsPerPage: number;
		sortBy: { key: string; order: "asc" | "desc" }[];
		"filter[available_in]"?: string;
	}): Promise<Result<LaravelPaginatedCollection<IntegrationDO>, ApiError>> {
		return wrapper(baseClient.get("integrations", { params }));
	}
	show(uuid: string): Promise<Result<IntegrationDO, ApiError>> {
		return wrapper(baseClient.get(`integrations/${uuid}`));
	}
	patch(integration: IntegrationDO): Promise<Result<IntegrationDO, ApiError>> {
		return wrapper(
			baseClient.patch(`integrations/${integration.uuid}`, integration)
		);
	}
	showActivity(
		params: {
			page: number;
			itemsPerPage: number;
			sortBy: { key: string; order: "asc" | "desc" }[];
		},
		uuid: string
	): Promise<
		Result<LaravelPaginatedCollection<IntegrationExecutionDO>, ApiError>
	> {
		return wrapper(baseClient.get(`integrations/${uuid}/activity`, { params }));
	}

	createExecution(
		integration: string,
		dataSource: string,
		body: object
	): Promise<Result<IntegrationExecutionDO, ApiError>> {
		return wrapper(
			baseClient.post(`integrations/${integration}/${dataSource}`, body)
		);
	}
	cancelExecution(
		Integration: string,
		integrationExecution: IntegrationExecutionDO
	): Promise<Result<IntegrationExecutionDO, ApiError>> {
		return wrapper(
			baseClient.patch(
				`integrations/${Integration}/cancel/${integrationExecution.uuid}`
			)
		);
	}
	downloadExecutionContents(
		Integration: string,
		integrationExecution: IntegrationExecutionDO
	): Promise<Result<object, ApiError>> {
		return wrapper(
			baseClient.post(
				`integrations/${Integration}/download/${integrationExecution.uuid}`
			)
		);
	}
}
